import { ProductTier } from '@sparemin/api-sdk';
import { ProBadgeGradient } from '@sparemin/blockhead';
import React from 'react';
import Modal from 'components/Modal';
import useBillingCycleModal from 'hooks/useBillingCycleModal';
import { replaceModal } from 'redux/modules/modal';
import useIsBlockingActionInProgress from '../useIsBlockingActionInProgress';
import { socialShareModalFooterBlock as block } from '../utils';

export type GatedScheduleButtonProps = {};

const GatedScheduleButton: React.FC<GatedScheduleButtonProps> = () => {
  const { openBillingCycleModal } = useBillingCycleModal();
  const isBlockingActionInProgress = useIsBlockingActionInProgress();

  const handleUpgrade = React.useCallback(() => {
    openBillingCycleModal(
      {
        tier: ProductTier.PRO,
        defaultSubscriptionPeriod: 'yearly',
        disableSuccessRedirect: true,
      },
      replaceModal,
    );
  }, [openBillingCycleModal]);

  return (
    <Modal.FooterButton
      theme="submit-alt"
      disabled={isBlockingActionInProgress}
      className={block('gated-schedule-button')}
      onClick={handleUpgrade}
    >
      Schedule
      <ProBadgeGradient width={28} height={17} />
    </Modal.FooterButton>
  );
};

export default GatedScheduleButton;
